// Apply only exact replacements from the server. Preserve new turns, drafts,
// pending actions and all other interaction state during a background response.
export const applyNarrationCorrections = (interaction, corrections = []) => {
  let changed = false;
  const messages = (interaction.messages || []).map(message => {
    if (message.role !== 'assistant' || message.pendingNarration) return message;
    let next = message;
    for (const correction of corrections) {
      if ((message.turnId == null || message.turnId === correction.turnId) && next.content === correction.previousText) {
        next = { ...next, content: correction.description, turnId: correction.turnId };
        changed = true;
      }
    }
    return next;
  });
  if (!changed) return interaction;
  let lastNarration = interaction.lastNarration;
  for (const correction of corrections) if (lastNarration?.description === correction.previousText
    && (lastNarration.turnId == null || lastNarration.turnId === correction.turnId)) {
    lastNarration = { ...lastNarration, description: correction.description, turnId: correction.turnId };
  }
  return { ...interaction, messages, history: messages, lastNarration,
    recentNarration: messages.filter(message => message.role === 'assistant' && !message.pendingNarration).slice(-8) };
};
